<template>
  <nav class="nav-container">
    <div class="logo" style="cursor: pointer;">
      <a href="https://masterprojekt.eu" style="cursor: pointer;"><img src="./assets/logo2.png" alt="Logo" style="cursor: pointer;"/></a>
    </div>
    <div class="title">MBH4 Katalogu Digjital</div>
    <div class="back-button">
      <a href="https://mbh4.masterprojekt.eu/" class="btn"><i class="fa fa-building-o" aria-hidden="true" style="font-size: 20px;"></i></a>
    </div>
  </nav>
  <router-view />
</template>

<!-- https://www.image-map.net/ -->
<style lang="scss">
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #333;
}

::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 20px;
  border: 2px solid #333;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #333;
  color: white;
}
.logo img {
  height: 40px;
}
.title {
  font-size: 20px;
  font-weight: bold;
}
.back-button .btn {
  background-color: #555;
  color: white;
  padding: 8px 12px;
  text-decoration: none;
  border-radius: 5px;
}
.back-button .btn:hover {
  background-color: #777;
}

@media (max-width: 768px) {
  .title {
  font-size: 15px;
  font-weight: bold;
  margin-left: -15px;
}
.logo img {
  height: 30px;
  margin-left: -15px;
}

}
</style>
